import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTA = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/10 via-accent/10 to-secondary/10 blur-3xl" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-6xl font-bold">
            Ready to Join the <span className="text-primary">Elite?</span>
          </h2>
          
          <p className="text-xl text-muted-foreground">
            Limited spots available. We're selective about who we work with.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Link to="/apply">
              <Button variant="premium" size="lg" className="group">
                Start Your Application
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/why">
              <Button variant="outline" size="lg">
                Learn More
              </Button>
            </Link>
          </div>
          
          <div className="pt-8">
            <p className="text-sm text-muted-foreground">
              Free to apply • Response within 48 hours
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
